// extracted by mini-css-extract-plugin
module.exports = {"content":"DepositMovileViewColumn_content__DpSk2","actions":"DepositMovileViewColumn_actions__ZwndD"};